import { mixed, number, object, string } from 'yup'

import { ACRISS_GROUP_BY } from '@constants'

const SITE_REQUIRED = 'Site is required when comparing inside a broker'

/**
 * `siteID` is only mandatory in Broker mode, where the table compares providers inside one
 * non-direct web. In Direct Sites mode an empty selection means "every direct site of the
 * execution", which the backend fills in. The signal can hold `null`, an array or a scalar
 * depending on the selector mode, and `[]` is truthy — hence the explicit emptiness check.
 */
const requireSite = isBrokerMode => mixed().nullable().test(
	'site-required-by-broker',
	SITE_REQUIRED,
	value => {
		if (!isBrokerMode) return true

		return Array.isArray(value) ? !!value.length : !!value
	}
)

/**
 * Whatever the third level of the header groups by is mandatory: an axis cannot be built out
 * of "every value the execution has". The other two dimensions are not even sent.
 */
const requireGroupBy = (isChosen, message) => mixed().nullable().test(
	'group-by-dimension',
	message,
	value => {
		if (!isChosen) return true

		return Array.isArray(value) ? !!value.length : !!value
	}
)

// Pickup Dates and LOR are optional: empty means "every value the execution has". The branch
// is not: the rows are providers, so the whole table hangs from a single dropoff office.
export const oneWaySchema = (searchID, isBrokerMode = false, groupBy = ACRISS_GROUP_BY.ACRISS_GROUP) => object({
	...!searchID && { officePickupID: number().required('Offices is required') },
	officeDropoffID: number().required('Branch is required'),
	siteID: requireSite(isBrokerMode),
	acrissGroupID: requireGroupBy(groupBy === ACRISS_GROUP_BY.ACRISS_GROUP, 'At least one acriss group is required'),
	acriss: requireGroupBy(groupBy === ACRISS_GROUP_BY.ACRISS, 'At least one acriss is required'),
	categoryID: requireGroupBy(groupBy === ACRISS_GROUP_BY.CATEGORY, 'At least one category is required'),
	currency: string().required('Currency is required'),
})
